import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPointsByOilDelivery, oilRecordDelivery } from '../../actions/oilActions';

import OilRegisterView from '../../containers/Oil/OilRegister/OilRegister'


import * as Yup from 'yup';
import { useFormik } from 'formik';


const OilRegister = ({ history }) => {

  const dispatch = useDispatch();
  const { ecopoints, about, isLoading, isLoadingPostRegister } = useSelector(state => state.oil);
  const { userInfo } = useSelector((state) => state.userInfo);

  const validationSchema = Yup.object().shape({
    email: Yup.string().email('correo electrónico invalido').required('Requerido'),
    quantity: Yup.number().test('msj', `no puede ser menor a ${about}`, (value) => { return value >= about }).required('Requerido'),
  });
  const [ecopointsValue, setEcopointsValue] = useState(ecopoints);

  useEffect(() => {
    dispatch(getPointsByOilDelivery())
    return () => {
    }
  }, []);

  useEffect(() => {
    if (ecopointsValue ===0) {
      setEcopointsValue(ecopoints);
    }
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      quantity: about,
    },
    validationSchema: validationSchema,
    onSubmit: (({ email, quantity }) => {
      if (userInfo.franchiseID) {
        if (userInfo.franchiseID.state === 2) {
          dispatch(oilRecordDelivery(email, quantity, userInfo.franchiseID._id, history));
        }
      }
      else if (userInfo.warehouseID) {
        dispatch(oilRecordDelivery(email, quantity, userInfo.warehouseID, history));
      }
    })
  })

  return (
    <>
      {
        !isLoading ?
          <OilRegisterView
            formik={formik}
            liters={about}
            ecopoints={ecopoints}
            ecopointsValue={ecopointsValue}
            setEcopointsValue={setEcopointsValue}
            isLoadingPostRegister={isLoadingPostRegister}
          /> :
          <div className="content-post content-not-enable-post">
            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </div>

      }
    </>
  )
}

export default OilRegister